import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy cây menu theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách các mục menu
 */
export const getNavMenuByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.NAVMENUS.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        let result = [];

        if (data && data.success && Array.isArray(data.data)) {
            result = data.data;
        } else if (Array.isArray(data)) {
            result = data;
        } else if (data && Array.isArray(data.data)) {
            result = data.data;
        }

        // Chuyển mảng phẳng thành cấu trúc cây nếu cần
        const isFlat = result.length > 0 && !result.some(item => Array.isArray(item.children));

        if (isFlat) {
            const map = {};
            const roots = [];

            result.forEach(node => {
                map[node.id] = { ...node, children: [] };
            });

            result.forEach(node => {
                if (node.parentId && map[node.parentId]) {
                    map[node.parentId].children.push(map[node.id]);
                } else {
                    roots.push(map[node.id]);
                }
            });

            const sortByOrder = (a, b) => (a.sortOrder ?? a.SortOrder ?? 0) - (b.sortOrder ?? b.SortOrder ?? 0);
            roots.sort(sortByOrder);
            Object.values(map).forEach(node => {
                if (node.children.length > 0) {
                    node.children.sort(sortByOrder);
                }
            });

            result = roots;
        }

        if (result.length > 0) {
            console.log(` [NavMenu] Lấy menu thành công (lang=${languageCode}):`, result);
        } else {
            console.warn(` [NavMenu] API trả về nhưng dữ liệu rỗng (lang=${languageCode}):`, data);
        }

        return result;
    } catch (error) {
        console.error(` [NavMenu] Lỗi khi lấy menu (lang=${languageCode}):`, error.message ?? error);
        throw error;
    }
};
